var map = {
	"./App.css": [
		90937,
		9,
		937
	],
	"./CombineProducts/CombineProducts": [
		94916,
		9,
		4916
	],
	"./CombineProducts/CombineProducts.js": [
		94916,
		9,
		4916
	],
	"./Coupons/Coupons": [
		33968,
		9,
		453,
		8229,
		3968
	],
	"./Coupons/Coupons.js": [
		33968,
		9,
		453,
		8229,
		3968
	],
	"./Coupons/CreateCoupon": [
		78229,
		9,
		8229,
		5161
	],
	"./Coupons/CreateCoupon.js": [
		78229,
		9,
		8229,
		5161
	],
	"./Coupons/EditCoupon": [
		10453,
		9,
		453
	],
	"./Coupons/EditCoupon.js": [
		10453,
		9,
		453
	],
	"./DailyTurnover/DailyTurnover": [
		13272,
		9,
		3272
	],
	"./DailyTurnover/DailyTurnover.js": [
		13272,
		9,
		3272
	],
	"./DailyTurnover/DailyTurnoverPDF": [
		63872,
		9,
		3872
	],
	"./DailyTurnover/DailyTurnoverPDF.js": [
		63872,
		9,
		3872
	],
	"./DuplicateProducts/CreateStandardDuplicate.png": [
		6411,
		1,
		6411
	],
	"./DuplicateProducts/DuplicateProducts": [
		58208,
		9,
		8208
	],
	"./DuplicateProducts/DuplicateProducts.js": [
		58208,
		9,
		8208
	],
	"./DuplicateProducts/ProductDuplicatePic.png": [
		22445,
		1,
		2445
	],
	"./InStore/CashRegisterContent": [
		48115,
		9,
		8115,
		8231
	],
	"./InStore/CashRegisterContent.js": [
		48115,
		9,
		8115,
		8231
	],
	"./InStore/Connection": [
		34498,
		9,
		4498
	],
	"./InStore/Connection.css": [
		26793,
		9,
		6793
	],
	"./InStore/Connection.js": [
		34498,
		9,
		4498
	],
	"./InStore/InStore": [
		33628,
		9,
		1175,
		8115,
		9896
	],
	"./InStore/InStore.js": [
		33628,
		9,
		1175,
		8115,
		9896
	],
	"./InStore/ManageButtons": [
		78436,
		9,
		8436
	],
	"./InStore/ManageButtons.css": [
		35949,
		9,
		5949
	],
	"./InStore/ManageButtons.js": [
		78436,
		9,
		8436
	],
	"./InStore/Modals/AdvertisementsModal": [
		45108,
		9,
		2727
	],
	"./InStore/Modals/AdvertisementsModal.js": [
		45108,
		9,
		2727
	],
	"./InStore/Modals/EditButtonModal": [
		21818,
		9,
		1818
	],
	"./InStore/Modals/EditButtonModal.js": [
		21818,
		9,
		1818
	],
	"./InStore/Modals/EditCountryModal": [
		59388,
		9,
		9388
	],
	"./InStore/Modals/EditCountryModal.js": [
		59388,
		9,
		9388
	],
	"./InStore/Modals/Modal.css": [
		78289,
		9,
		8289
	],
	"./InStore/Modals/PaymentMethodsModal": [
		61826,
		9,
		1826
	],
	"./InStore/Modals/PaymentMethodsModal.js": [
		61826,
		9,
		1826
	],
	"./InStore/Modals/PrefixModal": [
		80134,
		9,
		134
	],
	"./InStore/Modals/PrefixModal.js": [
		80134,
		9,
		134
	],
	"./InStore/Modals/ReceiptTextModal": [
		60459,
		9,
		459
	],
	"./InStore/Modals/ReceiptTextModal.js": [
		60459,
		9,
		459
	],
	"./InstallModal": [
		13147,
		9
	],
	"./InstallModal.js": [
		13147,
		9
	],
	"./LabelPrinter/LabelPrinter": [
		39834,
		9,
		9834
	],
	"./LabelPrinter/LabelPrinter.js": [
		39834,
		9,
		9834
	],
	"./LabelPrinter/LabelPrinterButton.png": [
		15092,
		1,
		5092
	],
	"./LabelPrinter/PriceLeftTemplate.png": [
		82742,
		1,
		2742
	],
	"./LabelPrinter/PriceRightTemplate.png": [
		12135,
		1,
		2135
	],
	"./LoyaltyPoints/LoyaltyPoints": [
		96164,
		9,
		6164
	],
	"./LoyaltyPoints/LoyaltyPoints.css": [
		89969,
		9,
		9969
	],
	"./LoyaltyPoints/LoyaltyPoints.js": [
		96164,
		9,
		6164
	],
	"./Myparcel/Myparcel": [
		80044,
		9,
		44
	],
	"./Myparcel/Myparcel.css": [
		24173,
		9,
		4173
	],
	"./Myparcel/Myparcel.js": [
		80044,
		9,
		44
	],
	"./NoBarcode/NoBarcode": [
		12492,
		9,
		2492
	],
	"./NoBarcode/NoBarcode.js": [
		12492,
		9,
		2492
	],
	"./NoBarcode/Nobarcode.css": [
		87585,
		9,
		7585
	],
	"./Picture_stylenumber/Picture_stylenumber": [
		93528,
		9,
		3528
	],
	"./Picture_stylenumber/Picture_stylenumber.css": [
		92885,
		9,
		2885
	],
	"./Picture_stylenumber/Picture_stylenumber.js": [
		93528,
		9,
		3528
	],
	"./ProductMeasurements/ProductMeasurements": [
		97536,
		9,
		7536
	],
	"./ProductMeasurements/ProductMeasurements.js": [
		97536,
		9,
		7536
	],
	"./Sale/Sale": [
		43892,
		9,
		6612,
		3892
	],
	"./Sale/Sale.css": [
		96585,
		9,
		6585
	],
	"./Sale/Sale.js": [
		43892,
		9,
		6612,
		3892
	],
	"./Sale/SaleConflictModal": [
		43129,
		9,
		3129
	],
	"./Sale/SaleConflictModal.css": [
		24672,
		9,
		4672
	],
	"./Sale/SaleConflictModal.js": [
		43129,
		9,
		3129
	],
	"./Sale/SaleDetailsModal": [
		23415,
		9,
		3415
	],
	"./Sale/SaleDetailsModal.js": [
		23415,
		9,
		3415
	],
	"./Sale/saleHelpers": [
		9519,
		9,
		9519
	],
	"./Sale/saleHelpers.js": [
		9519,
		9,
		9519
	],
	"./Saleschannels/CurrentBrands": [
		32475,
		9,
		2475
	],
	"./Saleschannels/CurrentBrands.js": [
		32475,
		9,
		2475
	],
	"./Saleschannels/CurrentCategories": [
		51541,
		9,
		1541
	],
	"./Saleschannels/CurrentCategories.js": [
		51541,
		9,
		1541
	],
	"./Saleschannels/CurrentPaymentMethods": [
		28945,
		9,
		8945
	],
	"./Saleschannels/CurrentPaymentMethods.js": [
		28945,
		9,
		8945
	],
	"./Saleschannels/CurrentProducts": [
		14017,
		9,
		4017
	],
	"./Saleschannels/CurrentProducts.js": [
		14017,
		9,
		4017
	],
	"./Saleschannels/Modals/NewSalesChannelModal": [
		89569,
		9,
		9569
	],
	"./Saleschannels/Modals/NewSalesChannelModal.js": [
		89569,
		9,
		9569
	],
	"./Saleschannels/SalesChannelTemplate": [
		41175,
		9,
		1175
	],
	"./Saleschannels/SalesChannelTemplate.js": [
		41175,
		9,
		1175
	],
	"./Saleschannels/Saleschannels": [
		33924,
		9,
		1175,
		3924
	],
	"./Saleschannels/Saleschannels.js": [
		33924,
		9,
		1175,
		3924
	],
	"./Seasons/ProductSeasonModal": [
		73339,
		9
	],
	"./Seasons/ProductSeasonModal.js": [
		73339,
		9
	],
	"./Seasons/ProductSeasonsBox": [
		56770,
		9
	],
	"./Seasons/ProductSeasonsBox.js": [
		56770,
		9
	],
	"./Seasons/SeasonModal": [
		91704,
		9,
		1704
	],
	"./Seasons/SeasonModal.js": [
		91704,
		9,
		1704
	],
	"./Seasons/Seasons": [
		8640,
		9,
		8640
	],
	"./Seasons/Seasons.js": [
		8640,
		9,
		8640
	],
	"./SeoDuplicates/SeoDuplicates": [
		23028,
		9,
		3028
	],
	"./SeoDuplicates/SeoDuplicates.js": [
		23028,
		9,
		3028
	],
	"./Shipping/Packages": [
		56877,
		9,
		6877
	],
	"./Shipping/Packages.js": [
		56877,
		9,
		6877
	],
	"./Shipping/Shipping": [
		15642,
		9,
		5642
	],
	"./Shipping/Shipping.js": [
		15642,
		9,
		5642
	],
	"./Shipping/packages.css": [
		44942,
		9,
		4942
	],
	"./ShippingExport/ExportBestelling.png": [
		80475,
		1,
		475
	],
	"./ShippingExport/ExportOverzicht.png": [
		5108,
		1,
		5108
	],
	"./ShippingExport/ShippingExport": [
		28538,
		9,
		8538
	],
	"./ShippingExport/ShippingExport.js": [
		28538,
		9,
		8538
	],
	"./TurnoverReports/ReportTable": [
		11078,
		9,
		1078,
		4488
	],
	"./TurnoverReports/ReportTable.js": [
		11078,
		9,
		1078,
		4488
	],
	"./TurnoverReports/TurnoverReportPDF": [
		81535,
		9,
		1535
	],
	"./TurnoverReports/TurnoverReportPDF.js": [
		81535,
		9,
		1535
	],
	"./TurnoverReports/TurnoverReports": [
		69512,
		9,
		1078,
		5299
	],
	"./TurnoverReports/TurnoverReports.js": [
		69512,
		9,
		1078,
		5299
	],
	"./UnifiedsmbPayments/AccountCreation": [
		53201,
		9,
		3201
	],
	"./UnifiedsmbPayments/AccountCreation.js": [
		53201,
		9,
		3201
	],
	"./UnifiedsmbPayments/AccountOverview": [
		49535,
		9,
		9535,
		385
	],
	"./UnifiedsmbPayments/AccountOverview.js": [
		49535,
		9,
		9535,
		385
	],
	"./UnifiedsmbPayments/AccountUbos": [
		40905,
		9,
		6612,
		905
	],
	"./UnifiedsmbPayments/AccountUbos.css": [
		64132,
		9,
		4132
	],
	"./UnifiedsmbPayments/AccountUbos.js": [
		40905,
		9,
		6612,
		905
	],
	"./UnifiedsmbPayments/MainPayments": [
		21721,
		9,
		1721
	],
	"./UnifiedsmbPayments/MainPayments.css": [
		17146,
		9,
		7146
	],
	"./UnifiedsmbPayments/MainPayments.js": [
		21721,
		9,
		1721
	],
	"./UnifiedsmbPayments/Modals/ActivateIdealModal": [
		35327,
		9,
		5327
	],
	"./UnifiedsmbPayments/Modals/ActivateIdealModal.js": [
		35327,
		9,
		5327
	],
	"./UnifiedsmbPayments/Modals/IbanModal": [
		67851,
		9,
		7851
	],
	"./UnifiedsmbPayments/Modals/IbanModal.js": [
		67851,
		9,
		7851
	],
	"./UnifiedsmbPayments/Modals/SalesLocationConfirmationModal": [
		3979,
		9,
		3979
	],
	"./UnifiedsmbPayments/Modals/SalesLocationConfirmationModal.js": [
		3979,
		9,
		3979
	],
	"./UnifiedsmbPayments/Modals/StatusInfoModal": [
		10043,
		9,
		43
	],
	"./UnifiedsmbPayments/Modals/StatusInfoModal.css": [
		24342,
		9,
		4342
	],
	"./UnifiedsmbPayments/Modals/StatusInfoModal.js": [
		10043,
		9,
		43
	],
	"./UnifiedsmbPayments/Terminal.png": [
		95323,
		1,
		5323
	],
	"./UnifiedsmbPayments/UnifiedsmbPayments": [
		97884,
		9,
		6612,
		9535,
		4874
	],
	"./UnifiedsmbPayments/UnifiedsmbPayments.js": [
		97884,
		9,
		6612,
		9535,
		4874
	],
	"./VariabelProductNumber/VariabelProductNumber": [
		60992,
		9,
		992
	],
	"./VariabelProductNumber/VariabelProductNumber.js": [
		60992,
		9,
		992
	],
	"./VariableProductPrice/VariablePrice.png": [
		76949,
		1,
		6949
	],
	"./VariableProductPrice/VariableProductPrice": [
		40626,
		9,
		626
	],
	"./VariableProductPrice/VariableProductPrice.js": [
		40626,
		9,
		626
	],
	"./VariablePurchasePrice/VariablePurchasePrice": [
		88644,
		9,
		8644
	],
	"./VariablePurchasePrice/VariablePurchasePrice.js": [
		88644,
		9,
		8644
	],
	"./WarehouseMutations/WarehouseMutations": [
		6132,
		9,
		6132
	],
	"./WarehouseMutations/WarehouseMutations.js": [
		6132,
		9,
		6132
	],
	"./WooCommerce/WooCommerce": [
		91452,
		9,
		1175,
		1452
	],
	"./WooCommerce/WooCommerce.css": [
		97257,
		9,
		7257
	],
	"./WooCommerce/WooCommerce.js": [
		91452,
		9,
		1175,
		1452
	],
	"./WooCommerce/WooCommerceInformation": [
		84872,
		9,
		4872
	],
	"./WooCommerce/WooCommerceInformation.js": [
		84872,
		9,
		4872
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19889;
module.exports = webpackAsyncContext;